import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propBool, propFunc, propStr } from '../../../helpers/custom-prop-types';
import { compose } from '../../../helpers/recompose';
import ExaminationAlertAndHeadCardModalContentBody from './ExaminationAlertAndHeadCardModalContentBody';
import ModalHoc from './ModalHoc';
const ExaminationAlertAndHeadCardFullModalInner = (props) => {
    const { modalState, onClickClose } = props;
    return (_jsxs("div", Object.assign({ className: `fade_modal alert-card-modal-full-background ${modalState}` }, { children: [_jsx("div", { className: 'bg', onClick: onClickClose, role: 'presentation' }), _jsx(ExaminationAlertAndHeadCardModalContentBody, { className: modalState, onClickClose: onClickClose })] })));
};
ExaminationAlertAndHeadCardFullModalInner.propTypes = {
    modalState: propStr().isRequired,
    onClickClose: propFunc().isRequired,
};
const enhance = compose(ModalHoc);
const ExaminationAlertAndHeadCardFullModal = enhance(ExaminationAlertAndHeadCardFullModalInner);
ExaminationAlertAndHeadCardFullModal.propTypes = {
    isShow: propBool().isRequired,
    onClickClose: propFunc().isRequired,
};
export default ExaminationAlertAndHeadCardFullModal;
